export default {
    metamask: "metamask",
    walletConnect: "wallet connect"
}